import { useMemo } from 'preact/hooks';

import CountryCodeList from './CountryCodeList';
import CountryCodeMenu from './CountryCodeMenu';
import CountryCodeMenuButton from './CountryCodeMenuButton';
import SearchInput from './SearchInput';

export default function CountryCodeSelector() {
  const menu = useMemo(
    () => (
      <div className='absolute z-50 mt-2 w-60 rounded-md border bg-white shadow-lg'>
        <div className='space-y-2 p-2'>
          <SearchInput />
          <CountryCodeList />
        </div>
      </div>
    ),
    [],
  );

  return (
    <CountryCodeMenu>
      <CountryCodeMenuButton />
      {menu}
    </CountryCodeMenu>
  );
}
